import _classCallCheck from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import isSchema from './util/isSchema';
export function create(builder) {
  return new Lazy(builder);
}
var Lazy = /*#__PURE__*/function () {
  function Lazy(builder) {
    var _this = this;
    _classCallCheck(this, Lazy);
    this.type = 'lazy';
    this.__isYupSchema__ = true;
    this.__inputType = void 0;
    this.__outputType = void 0;
    this._resolve = function (value) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var schema = _this.builder(value, options);
      if (!isSchema(schema)) throw new TypeError('lazy() functions must return a valid schema');
      return schema.resolve(options);
    };
    this.builder = builder;
  }
  return _createClass(Lazy, [{
    key: "resolve",
    value: function resolve(options) {
      return this._resolve(options.value, options);
    }
  }, {
    key: "cast",
    value: function cast(value, options) {
      return this._resolve(value, options).cast(value, options);
    }
  }, {
    key: "validate",
    value: function validate(value, options, maybeCb) {
      // @ts-expect-error missing public callback on type
      return this._resolve(value, options).validate(value, options, maybeCb);
    }
  }, {
    key: "validateSync",
    value: function validateSync(value, options) {
      return this._resolve(value, options).validateSync(value, options);
    }
  }, {
    key: "validateAt",
    value: function validateAt(path, value, options) {
      return this._resolve(value, options).validateAt(path, value, options);
    }
  }, {
    key: "validateSyncAt",
    value: function validateSyncAt(path, value, options) {
      return this._resolve(value, options).validateSyncAt(path, value, options);
    }
  }, {
    key: "describe",
    value: function describe() {
      return null;
    }
  }, {
    key: "isValid",
    value: function isValid(value, options) {
      return this._resolve(value, options).isValid(value, options);
    }
  }, {
    key: "isValidSync",
    value: function isValidSync(value, options) {
      return this._resolve(value, options).isValidSync(value, options);
    }
  }]);
}();
export default Lazy;